<form>
  @if (title.length) {
    <div class="p-3 pt-2">
      <h4 class="{{titleClass}}" data-testid="alert-title" id="alert-title">
        {{title | translate:sanitizedTranslationParams}}
      </h4>
    </div>
  }
  <div class="p-3 py-0">
    @if (message.length) {
      <p class="pre-wrap break-word" [innerHTML]="message | translate:sanitizedTranslationParams"></p>
    }
  </div>
  <div class="p-3 d-flex gap-2 justify-content-end">
    @if (buttonsVisibility.showCancelButton) {
      <button #cancelButton
        type="button"
        class="btn btn-secondary btn-cancel"
        (click)="cancel()"
        (keyup.enter)="cancel()"
        (keydown.enter)="$event.preventDefault()"
        data-testid="alert-cancel"
        id="alert-cancel">
        {{ 'global.label.cancel' | translate }}
      </button>
    }
    @if (buttonsVisibility.showNoButton) {
      <button #noButton
        type="button"
        class="btn btn-secondary btn-forward"
        (click)="no()"
        (keyup.enter)="no()"
        (keydown.enter)="$event.preventDefault()"
        data-testid="alert-no"
        id="alert-no">
        {{noButtonLabel | translate}}
      </button>
    }
    @if (buttonsVisibility.showOkButton) {
      <button #okButton
        type="button"
        class="btn btn-primary btn-forward"
        (click)="ok()"
        (keyup.enter)="ok()"
        (keydown.enter)="$event.preventDefault()"
        data-testid="alert-confirm"
        id="alert-ok">
        {{'global.label.ok' | translate}}
      </button>
    }
    @if (buttonsVisibility.showYesButton) {
      <button #yesButton
        type="button"
        class="btn btn-primary btn-forward"
        (click)="yes()"
        (keyup.enter)="yes()"
        (keydown.enter)="$event.preventDefault()"
        data-testid="alert-confirm"
        id="alert-yes">
        {{yesButtonLabel | translate}}
      </button>
    }
    @if (buttonsVisibility.showNextButton) {
      <button #nextRef
        type="button"
        class="btn btn-primary btn-forward"
        (click)="next()"
        (keyup.enter)="next()"
        (keydown.enter)="$event.preventDefault()"
        data-testid="alert-confirm"
        id="step_forward">
        {{ nextButtonLabel | translate}}
      </button>
    }
  </div>
</form>
